import { A, RouteSectionProps, useNavigate } from '@solidjs/router'
import {
    Component,
    createEffect,
    createMemo,
    onCleanup,
    onMount,
    Show,
} from 'solid-js'

import { api_admin_companies_patch } from 'abi'
import { addAlert, HoverInp, LoadingDots, setPopup } from 'components'
import {
    CheckFillIcon,
    CloseIcon,
    CorpsIcon,
    DeleteIcon,
    EditIcon,
    InsuranceIcon,
    UsersIcon,
    WarningIcon,
} from 'icons'
import { JSX } from 'solid-js'
import { createStore, unwrap } from 'solid-js/store'
import { self } from 'store/self'
import {
    cState,
    DelCorp,
    fetchCorp,
    isAdmin,
    isInCorp,
    ResetCstate,
    setCState,
} from './shared'
import './style/corp.scss'

const Corp: Component<RouteSectionProps> = P => {
    let nav = useNavigate()

    const Corpid = createMemo((): null | number => {
        let id = P.params.id

        if (!id || isNaN(parseInt(id))) return null

        return parseInt(id)
    })

    onMount(() => {
        if (!Corpid()) return setCState({ loading: false, error: true })

        if (isAdmin()) {
            fetchCorp(Corpid()!, true)
        }

        if (isInCorp(Corpid()!)) {
            fetchCorp(Corpid()!, false)
        }

        if (self.staff_role == 'agent') {
            nav('insurances')
        }

        if (!isAdmin() && !isInCorp(Corpid()!)) {
            return nav('/panel/403', { replace: true })
        }

        return
    })

    onCleanup(() => {
        ResetCstate()
    })

    const Loading: Component = () => {
        return (
            <div class='corp-loading'>
                <img src='/public/imgs/logo.png' decoding='async' alt='' />

                <p class='title'>درحال گرفتن اطلاعات از سرور</p>
            </div>
        )
    }
    const Error: Component = () => {
        return (
            <div class='corp-error'>
                <CloseIcon />

                <p class='title'>خطا در گرفتن اطلاعات از سرور</p>
            </div>
        )
    }

    const DelBtn = () => {
        return (
            <div
                role='button'
                class='del-corp-btn corp-btn'
                onclick={() => {
                    setPopup({
                        show: true,
                        title: 'شرکت را حذف میکنید؟',
                        content:
                            'بعد از حذف شرکت، تمام نماینده ها و مدیرعاملان به حالت کاربر ساده باز میگردند.',
                        timer: 3,
                        Icon: DeleteIcon,
                        type: 'error',
                        onSubmit() {
                            let name = unwrap(cState.corp)

                            DelCorp(Corpid()!, () => {
                                addAlert({
                                    type: 'success',
                                    timeout: 3,
                                    subject: 'موفق!',
                                    content: `شرکت ${name} با موفقیت حذف شد.`,
                                })
                                nav('/panel/corporations')
                            })
                        },
                    })
                }}
            >
                <DeleteIcon />
            </div>
        )
    }
    const EditBtn = () => {
        return (
            <div
                role='button'
                class='edit-corp-btn corp-btn'
                onclick={() => {
                    setCState({ edit: true })
                }}
            >
                <EditIcon />
            </div>
        )
    }

    return (
        <div class='corp-page section'>
            <EditName
                show={cState.edit}
                name={cState.corp?.name || ''}
                onClose={() => {
                    setCState({ edit: false })
                }}
                onEdit={n => {
                    setCState('corp', 'name', n)
                }}
            />

            <div class='corp-wrapper'>
                <Show when={!cState.loading} fallback={<Loading />}>
                    <Show when={!cState.error} fallback={<Error />}>
                        <Show when={isAdmin()}>
                            <div class='master-ctas'>
                                <EditBtn />
                                <DelBtn />
                            </div>
                        </Show>
                        <div class='corp-name section_title2'>
                            {cState.corp?.name || 'بدون نام'}
                        </div>

                        <CorpNav />

                        <div class='corp-outlet'>{P.children}</div>
                    </Show>
                </Show>
            </div>
        </div>
    )
}

const CorpNav: Component = () => {
    interface LinkProps {
        title: string
        link: string
        icon: JSX.Element
    }
    const Link: Component<LinkProps> = P => {
        return (
            <A
                href={P.link}
                class='nav-link'
                inactiveClass=''
                end
                // classList={{ disable: P.disabled }}
                // onclick={e => {
                //     if (P.disabled) {
                //         e.preventDefault()
                //         e.stopImmediatePropagation()
                //         e.stopPropagation()
                //     }
                // }}
            >
                <div class='icon-wrapper'>
                    <div class='icon'>{P.icon}</div>
                    <div class='icon abs'>{P.icon}</div>
                </div>
                {P.title}
            </A>
        )
    }

    return (
        <div class='corp-nav title_small'>
            <Show
                when={self.staff_role == 'manager' || isAdmin()}
                fallback={
                    <div class='link-wrapper'>
                        <Link
                            title='بیمه ها'
                            icon={<InsuranceIcon />}
                            link='insurances'
                        />
                    </div>
                }
            >
                <div class='link-wrapper'>
                    <Link title='اعضا' icon={<UsersIcon />} link='' />
                </div>
                <div class='link-wrapper'>
                    <Link
                        title='بیمه ها'
                        icon={<InsuranceIcon />}
                        link='insurances'
                    />
                </div>
                <div class='link-wrapper'>
                    <Link
                        title='الحاقیه ها'
                        icon={<EditIcon />}
                        link='corrections'
                    />
                </div>
            </Show>
        </div>
    )
}

interface AddCorpCmpProps {
    onClose(): void

    show: boolean
    name: string
    onEdit(name: string): void
}
const EditName: Component<AddCorpCmpProps> = P => {
    type STATE = {
        loading: boolean
        status: null | 'green' | 'red'

        name: string

        error: boolean

        anim: boolean
    }
    const [state, setState] = createStore<STATE>({
        loading: false,
        status: null,
        name: '',

        error: false,

        anim: false,
    })

    createEffect(() => {
        if (!P.show) closed()

        setState({
            name: P.name || '',
        })
    })

    const closed = () => {
        setState({
            loading: false,
            status: null,
            name: '',

            anim: false,
        })
    }

    const isDisable = createMemo(() => state.name.length < 3)

    const checkForm = async () => {
        if (!cState.corp!.id) return

        if (isDisable()) {
            return setState({ error: true })
        }

        if (state.loading || state.status) return

        setState({ loading: true })

        let res = await api_admin_companies_patch(
            { id: cState.corp!.id },
            {
                name: state.name,
            }
        )

        setState({ loading: false })

        if (!res.ok()) return setState({ status: 'red' })

        setState({ status: 'green' })

        P.onEdit(res.body.name)
    }

    const OnClose = () => {
        if (state.loading) return

        if (state.status == 'red')
            return setState({ loading: false, error: false })

        P.onClose()
    }

    return (
        <div
            class='edit-corp-cmp'
            classList={{ show: P.show }}
            onclick={OnClose}
        >
            <div
                class='edit-corp-wrapper'
                onclick={e => {
                    e.stopPropagation()
                }}
            >
                <div
                    class='scaler'
                    onanimationend={() => setState({ anim: true })}
                ></div>

                <form
                    onsubmit={e => {
                        e.preventDefault()
                        checkForm()
                    }}
                    class='card'
                >
                    <button class='close icon' type='button' onclick={OnClose}>
                        <CloseIcon />
                    </button>
                    <div class='logo-wrapper'>
                        <img
                            class='logo'
                            decoding='async'
                            src='/public/imgs/logo.png'
                            alt=''
                        />
                        <div class='add-head'>
                            <p class='title_smaller sub'>اسم شرکت در</p>
                            <p class='section_title main'>بیمه همراه</p>
                        </div>
                    </div>
                    <div class='hover-wrapper'>
                        <HoverInp
                            Icon={<CorpsIcon />}
                            holder='اسم شرکت'
                            acitve={state.name.length !== 0}
                            inpType='text'
                            onInp={e => setState({ name: e, error: false })}
                            value={state.name}
                        />
                        <div
                            class='error-wrapper title_smaller'
                            classList={{ show: state.error }}
                        >
                            <WarningIcon />
                            اسم شرکت را به درستی وارد کنید!
                        </div>
                    </div>

                    <div class='cta-wrapper title_small'>
                        <button
                            class='cta'
                            type='submit'
                            classList={{ disable: isDisable() }}
                        >
                            ثبت
                        </button>
                    </div>

                    <div
                        class='loader title_hero'
                        classList={{ show: state.loading }}
                    >
                        <LoadingDots />
                        درحال ثبت شرکت
                    </div>
                    <div
                        class='status-wrapper'
                        classList={{
                            show: !!state.status,
                            [state.status || '']: true,
                        }}
                    >
                        <Show
                            when={state.status == 'green'}
                            fallback={<CloseIcon />}
                        >
                            <CheckFillIcon />
                        </Show>

                        <p class='title_hero'>
                            <Show
                                when={state.status == 'green'}
                                fallback={
                                    'خطا در ثبت شرکت، لطفا دوباره تلاش کنید.'
                                }
                            >
                                شرکت با موفقیت ثبت شد!
                            </Show>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Corp
